// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__10w44","notes":"Notes_notes__1fPsq"};